export function zone(){
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}